// Navegación móvil: cabecera superior + barra inferior tipo app con scroll
// horizontal (mismo diseño que la app principal). En escritorio usa Sidebar.
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { LogOut, Terminal } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';
import { cn } from '@/lib/utils';
import { NAV_ITEMS, isNavActive } from './Sidebar';

export function MobileHeader() {
  const { pathname } = useLocation();
  const { logout, navigateToTerminal } = useAuth();
  const active = NAV_ITEMS.find((n) => isNavActive(n.path, pathname)) ?? NAV_ITEMS[0];

  return (
    <header className="md:hidden sticky top-0 z-40 flex items-center justify-between gap-3 px-4 py-3 border-b border-white/10 bg-gray-950/95 backdrop-blur-xl">
      <div className="flex items-center gap-3 min-w-0">
        <img src="/LogoGreenpr.png" alt="Green Vape" className="h-8 w-8 shrink-0 object-contain" />
        <h1 className="text-base font-bold text-white truncate">{active.label}</h1>
      </div>
      <div className="flex items-center gap-1 shrink-0">
        <button type="button" onClick={navigateToTerminal} aria-label="Terminal"
          className="p-2 rounded-lg text-white/50 hover:text-white hover:bg-white/10 transition-colors">
          <Terminal className="h-4 w-4" />
        </button>
        <button type="button" onClick={logout} aria-label="Cerrar sesión"
          className="p-2 rounded-lg text-white/40 hover:text-red-400 hover:bg-red-500/10 transition-colors">
          <LogOut className="h-4 w-4" />
        </button>
      </div>
    </header>
  );
}

export function BottomNav() {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 md:hidden border-t border-white/10 bg-gray-950/95 backdrop-blur-xl pb-[env(safe-area-inset-bottom)]">
      <div className="flex overflow-x-auto scrollbar-none">
        {NAV_ITEMS.map(({ path, label, icon: Icon }) => {
          const active = isNavActive(path, pathname);
          return (
            <button
              key={path}
              type="button"
              onClick={() => navigate(path)}
              className={cn(
                'relative flex shrink-0 flex-col items-center justify-center gap-0.5 py-2 px-3 min-w-[68px] transition-colors active:scale-95',
                active ? 'text-blue-400' : 'text-white/40 hover:text-white/70'
              )}
            >
              <Icon className={cn('h-5 w-5 shrink-0', active && 'scale-110 transition-transform')} />
              <span className="text-[10px] leading-tight font-medium whitespace-nowrap">{label}</span>
              {active && <span className="absolute bottom-0 h-0.5 w-6 rounded-full bg-blue-400" />}
            </button>
          );
        })}
      </div>
    </nav>
  );
}
